module.exports = __webpack_public_path__ + "img/Group 427320386.5ca41d23.svg";